// src/utils/loadmixcloudwidget.js
const MIXCLOUD_WIDGET_API_URL = '//widget.mixcloud.com/media/js/widgetApi.js';

export const loadMixcloudWidgetApi = () => {
  if (typeof window === 'undefined') return Promise.resolve();

  // Already loaded
  if (window.Mixcloud) return Promise.resolve(window.Mixcloud);

  // In-flight load
  if (window.__mixcloudWidgetApiPromise) {
    return window.__mixcloudWidgetApiPromise;
  }

  window.__mixcloudWidgetApiPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = MIXCLOUD_WIDGET_API_URL;
    script.async = true;
    script.onload = () => resolve(window.Mixcloud);
    script.onerror = () =>
      reject(new Error('Failed to load Mixcloud widget API'));
    document.head.appendChild(script);
  });

  return window.__mixcloudWidgetApiPromise;
};